import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import {Subject, Subscription} from 'rxjs';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {Columns} from '../..';

export type HeaderSearchEvent = { key: string; value: string };

@Component({
  selector: 'table-header',
  templateUrl: './header.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnDestroy {
  @Input() column: Columns;
  @Output() readonly update = new EventEmitter<HeaderSearchEvent>();

  private inputSubject = new Subject<HeaderSearchEvent>();
  private subscription: Subscription;

  constructor() {
    this.subscription = this.inputSubject.pipe(
      debounceTime(1000),
      distinctUntilChanged()
    ).subscribe(value => {
      if (value) {
        this.update.emit(value);
      }
    });
  }

  unifyKey(key: string): string {
    return key.replace('.', '_');
  }

  onKey(input: HTMLInputElement, $event: KeyboardEvent) {
    if ($event.code == 'Enter') {
      this.inputSubject.next(null);

      this.update.emit({value: input.value, key: this.column.key});
    }
  }

  onSearch(input: HTMLInputElement): void {
    this.inputSubject.next({value: input.value, key: this.column.key});
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.inputSubject.complete();
  }
}
